import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/museum-graphia", label: "Museum Graphia" },
  { to: "/corte-della-miniera", label: "Corte della Miniera" },
  { to: "/servizi", label: "Servizi & Laboratori" },
  { to: "/progetti", label: "Progetti" },
  { to: "/progetti-sartoriali", label: "Sartoriale" },
  { to: "/contatti", label: "Contatti" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-[#F9F8F6]/85 border-b border-[#E2DFD6]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo-wheel.png" alt="Museum Graphia" className="h-10 w-10 object-contain" />
          <div className="leading-none">
            <div className="font-display text-xl text-[#1A1A1A]">Corte della Miniera</div>
            <div className="overline text-[10px] mt-0.5">Urbino · Museum Graphia</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.to.replace(/\//g, "")}`}
              className={`link-underline text-sm ${pathname === l.to ? "text-[#8C3A27]" : "text-[#1A1A1A]"}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="tel:+393665959253" className="hidden xl:inline-flex text-sm text-[#6B6960] hover:text-[#8C3A27]">+39 366 595 9253</a>
          <Link to="/prenota" className="hidden lg:inline-flex">
            <Button data-testid="nav-book-btn" className="btn-primary-cdm rounded-full px-5">
              Prenota
            </Button>
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-[#1A1A1A]"
            onClick={() => setOpen(!open)}
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E2DFD6] bg-[#F9F8F6]">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-[#1A1A1A] py-1">
                {l.label}
              </Link>
            ))}
            <Link to="/prenota" onClick={() => setOpen(false)}>
              <Button className="btn-primary-cdm w-full rounded-full mt-2">Prenota</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
